import {Button, Image} from "antd";
import examinePng from "../../../assets/examine.png";
import Tips from "./tips";
import React, {useState} from "react";
import {WeChatOrganizationTypeDict} from "../../../config/MerchantType";
import {useSelector} from "react-redux";
import {subMerchantMaterialInfoSelector} from "../../../store/merchant";
import StepController from "./stepController";
import EventDispatcher from "../../../events";
import {WxSubMchStateQueryEvent} from "../../../events/WxSubMchStateQueryEvent";
import QrCodeGenerator from 'qrcode';

const WaitCheck = () => {
    let {requestNo, organizationType, merchantShortName, wxRequestNo} = useSelector(subMerchantMaterialInfoSelector);
    const nextStepAction = async () => {
        return await EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    };
    return (
        <>
            <div className='examine'>
                <div className='examine_state flex'>
                    <Image src={examinePng} width={58} height={60}/>
                    <div className='examine_tips'>
                        <p className='title wait'>材料已经提交，待审核</p>
                        <p className='wait'>您的申请已经成功提交，小微商户10分钟后可重新查询结果，个体商户/企业商户将于3-15个工作日内处理完毕，请耐心等待，<br/>
                            相关信息我们会及时通知给你，如有疑问，请咨询磁力圈客服。</p>
                    </div>
                </div>
                <div>
                    <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                    <p>微信申请编号：<span className='themeColor'>{wxRequestNo ? wxRequestNo : '请刷新查看微信申请编号'}</span></p>
                    <p>商户类型：<span
                        className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span>
                    </p>
                    <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
                </div>
            </div>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true} nexStepButtonName={'刷新'} refresh={true}
                            nextStepAction={nextStepAction}/>
        </>
    );
};
const QRCode = (props) => {
    let {tips, qrcode} = props;
    const [code, setCode] = useState('');
    const qrcodeGenerator = () => {
        return QrCodeGenerator.toDataURL(qrcode);
    };
    if (qrcode) {
        qrcodeGenerator().then((url) => {
            setCode(url);
        });
    }
    return qrcode ? (<div className='qrCode'>
        <Tips ctx={tips}/>
        <Image width={150} height={150} src={code}/>
    </div>) : '';
};
const tips1 = {ctx: '请使用管理员微信扫描下方二维码进行签约！', type: 'error'};
const tips2 = {ctx: '请使用法人微信扫描下方二维码完成账户验证！', type: 'error'};

const WaitAccountVerify = () => {
    let {
        requestNo,
        organizationType,
        merchantShortName,
        wxRequestNo,
        legalQRCode
    } = useSelector(subMerchantMaterialInfoSelector);
    const nextStepAction = async () => {
        return await EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    };
    return (
        <>
            <div className='examine'>
                <div className='examine_state flex'>
                    <Image src={examinePng} width={58} height={60}/>
                    <div className='examine_tips'>
                        <p className='title wait'>待账户验证</p>
                        <div className='wait'>
                            您的申请微信支付平台需要您的账户验证，您可以用两种方法完成账号验证。<br/>
                            <p className="verifyTip">1）请使用指定户名的银行账户户名的银行账户，汇款0.01元至财付通指定银行账户，完成验证,后点击刷新按钮查看进件状态。（30天有效期）；</p>
                            <p className="verifyTip">2）法人微信扫下面的二维码，完成验证</p>
                            相关信息我们会及时通知给你，如有疑问，请咨询磁力圈客服。
                        </div>
                    </div>
                </div>
                <div>
                    <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                    <p>微信申请编号：<span className='themeColor'>{wxRequestNo ? wxRequestNo : '请刷新查看微信申请编号'}</span></p>
                    <p>商户类型：<span
                        className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span>
                    </p>
                    <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
                </div>
                <QRCode tips={tips2} qrcode={legalQRCode}/>
            </div>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true} nexStepButtonName={'刷新'} refresh={true}
                            nextStepAction={nextStepAction}/>
        </>
    );
};
const Refuse = (props) => {
    let {
        message,
        organizationType,
        merchantShortName,
        requestNo,
        wxRequestNo,
        errors
    } = useSelector(subMerchantMaterialInfoSelector);
    let tipCtx = {ctx: message, type: 'error'};
    const nextStepAction = async () => {
        return await EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    };
    return (
        <div className='examine'>
            <div className='examine_state flex'>
                <Image src={examinePng} width={58} height={60}/>
                <div className='examine_tips'>
                    <p className='title refuse'>您提交的材料，已驳回！</p>
                    <Tips ctx={tipCtx}/>
                    <p className='refuse'>
                        您的申请未通过审核，您可以选择重新进件；<br/>
                        {errors.map((error) => {
                            return (<>{error}<br/></>)
                        })}
                    </p>
                </div>
            </div>
            <div>
                <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                {wxRequestNo ? <p>微信申请编号：<span className='themeColor'>{wxRequestNo}</span></p> : null}
                <p>商户类型：<span
                    className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span></p>
                <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
            </div>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true} nexStepButtonName={'刷新'} refresh={true}
                            nextStepAction={nextStepAction}/>
        </div>
    );
}

const Passed = () => {
    let {requestNo, organizationType, merchantShortName, wxRequestNo} = useSelector(subMerchantMaterialInfoSelector);
    return (
        <>
            <div className='examine'>
                <div className='examine_state flex'>
                    <Image src={examinePng} width={58} height={60}/>
                    <div className='examine_tips'>
                        <p className='title checked'>您提交的材料已经审核通过，等待签约</p>
                        <p className='checked'>您的申请已经通过微信支付平台的审核，接下来需要您按照步骤完成微信商户签约，如有疑问，请咨询磁力圈客服。</p>
                    </div>
                </div>
                <div>
                    <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                    <p>微信申请编号：<span className='themeColor'>{wxRequestNo}</span></p>
                    <p>商户类型：<span
                        className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span>
                    </p>
                    <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
                </div>
            </div>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true} nexStepButtonName={'去签约'}
                            nextStepAction={async () => {
                                return true;
                            }}/>
        </>
    );
}

const SignQRCode = () => {
    let
        {
            organizationType,
            merchantShortName,
            requestNo,
            wxRequestNo,
            creatorQRCode,
        }
            = useSelector(subMerchantMaterialInfoSelector);
    const nextStepAction = async () => {
        return await EventDispatcher.dispatch(new WxSubMchStateQueryEvent());
    };
    return (
        <div className='examine'>
            <div className='examine_state flex'>
                <Image src={examinePng} width={58} height={60}/>
                <div className='examine_tips'>
                    <p className='title checked'>您的申请已经通过，请用微信扫描下面的二维码，完成签约。</p>
                    <p className='checked'>
                        您的申请通过审核，请完成最后的签约步骤；
                        <br/>
                        若想修改下方商户信息，也可以重新认证修改，成功签约后将无法修改
                    </p>
                </div>
            </div>
            <div>
                <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                <p>微信申请编号：<span className='themeColor'>{wxRequestNo}</span></p>
                <p>商户类型：<span
                    className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span></p>
                <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
            </div>
            <QRCode tips={tips1} qrcode={creatorQRCode}/>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true} nexStepButtonName={'已扫码签约'}
                            refresh={true} nextStepAction={nextStepAction}/>
        </div>
    )
        ;
}

const Success = () => {
    let {requestNo, organizationType, merchantShortName, wxRequestNo} = useSelector(subMerchantMaterialInfoSelector);
    return (
        <>
            <div className='examine'>
                <div className='examine_state flex'>
                    <Image src={examinePng} width={58} height={60}/>
                    <div className='examine_tips'>
                        <p className='title success'>恭喜您微信支付商户进件成功！！！！</p>
                        <p className='success'>恭喜您您的微信支付商户进件成功，后面平台交易中的款项会直接结算进入你的小微账号，<br/>
                            如有疑问，请咨询磁力圈客服。</p>
                        <p className='success'>{WeChatOrganizationTypeDict.SUB_MCH_AMOUNT_LIMIT_DESC[organizationType]}</p>
                    </div>
                </div>
                <div>
                    <p>业务单号：<span className='themeColor'>{requestNo}</span></p>
                    <p>微信申请编号：<span className='themeColor'>{wxRequestNo ? wxRequestNo : '请刷新查看微信申请编号'}</span></p>
                    <p>商户类型：<span
                        className='themeColor'>{WeChatOrganizationTypeDict.ORGANIZATION_TYPES[organizationType]}</span>
                    </p>
                    <p>商户简称：<span className='themeColor'>{merchantShortName}</span></p>
                </div>
            </div>
            <StepController preStepButtonName={'重新进件'} resetMaterial={true}/>
        </>
    );
};
export {Refuse, SignQRCode, WaitCheck, Passed, WaitAccountVerify, Success};